<dx-data-grid id="allOrganisationsGrid"
              [dataSource]="gridData"
              [stateStoring]="gridHelper?.stateStoringOptions"
              [columnAutoWidth]="true"
              [allowColumnResizing]="true"
              [allowColumnReordering]="true"
              [rowAlternationEnabled]="true"
              [hoverStateEnabled]="true"
              [showRowLines]="true"
              [showBorders]="true"
              (onInitialized)="onGridInitialized($event)">
    <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
    <dxo-data-grid-load-panel [enabled]="true"></dxo-data-grid-load-panel>
    <dxo-data-grid-paging [pageSize]="15"></dxo-data-grid-paging>
    <dxo-data-grid-pager [showPageSizeSelector]="true"
                         [allowedPageSizes]="[15, 25, 50, 100, 250]"></dxo-data-grid-pager>
    <dxo-data-grid-column-fixing [enabled]="true"></dxo-data-grid-column-fixing>

    <dxi-data-grid-column caption="Name"
                          dataField="organisation.name"
                          dataType="string"
                          sortOrder="asc"
                          cellTemplate="nameCellTemplate"></dxi-data-grid-column>

    <dxi-data-grid-column caption="Coach"
                          dataField="coaches"
                          dataType="string"
                          cellTemplate="coachCellTemplate"></dxi-data-grid-column>

    <dxi-data-grid-column caption="Active Customers"
                          dataField="active"
                          dataType="boolean"
                          [filterValue]="true"></dxi-data-grid-column>

    <div *dxTemplate="let item of 'nameCellTemplate'">
        <button class="btn btn-link"
                (click)="switchToOrganisation(item.data.organisation)"
                [disabled]="isDisabled">
            {{ item.data.organisation.name }}
        </button>
    </div>

    <div *dxTemplate="let item of 'coachCellTemplate'">
        <ul>
            @for (coachName of item.data.coaches; track coachName) {
                <li>
                    {{ coachName }}
                </li>
            }
        </ul>
    </div>
</dx-data-grid>
